export enum ActionTypes {
    CONFIG_LOADED = 'SF_CONFIG_LOADED',
    UI_INTEGRATE_UPDATED = 'SF_UI_INTEGRATE_UPDATED',
    UI_BYOD_UPDATED = 'SF_UI_BYOD_UPDATED',
    UI_WEBHOOK_UPDATED = 'SF_UI_WEBHOOK_UPDATED',
}



// WEBPACK FOOTER //
// ./src/sub-projects/fusionfabric/types/action-types.ts